/**
 * BulkActionsToolbar Component
 * Toolbar for bulk file operations - now uses BulkActionBar from component library
 */

import React from 'react';
import { BulkActionBar } from '@/components/ccms-components/file-management';
import { SelectedFilesState } from '../types';

interface BulkActionsToolbarProps {
  selectedFiles: SelectedFilesState;
  onBulkDelete: () => void;
  onBulkMove: () => void;
  onBulkDownload: () => void;
  onClearSelection: () => void;
}

export const BulkActionsToolbar: React.FC<BulkActionsToolbarProps> = ({
  selectedFiles,
  onBulkDelete,
  onBulkMove,
  onBulkDownload,
  onClearSelection,
}) => {
  const selectedCount = selectedFiles.fileIds.size;

  return (
    <BulkActionBar
      selectedCount={selectedCount}
      onDelete={onBulkDelete}
      onMove={onBulkMove}
      onDownload={onBulkDownload}
      onClear={onClearSelection}
      gradientVariant="primary"
    />
  );
};
